import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Icon } from '@/components/Icon';

export interface EmptyStateProps {
  icon: string;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
  className?: string;
  testId?: string;
}

/** One designed empty state: icon tile + one line in the product's voice + the action (screen 26, state 01). */
export function EmptyState({ icon, title, description, action, compact, className, testId }: EmptyStateProps) {
  return (
    <div data-testid={testId} className={cn('flex flex-col items-center text-center', compact ? 'gap-2.5 px-4 py-8' : 'gap-3 px-6 py-12', className)}>
      <div className="relative">
        <div className={cn('flex items-center justify-center rounded-lg border border-dashed border-border-strong bg-secondary text-muted-foreground', compact ? 'size-11' : 'size-14')}>
          <Icon name={icon} size={compact ? 22 : 28} />
        </div>
        {action ? (
          <span aria-hidden className="absolute -bottom-1.5 -right-1.5 flex size-5 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-card">
            <Icon name="add" size={14} />
          </span>
        ) : null}
      </div>
      <div>
        <h3 className="text-[15px] font-semibold text-foreground">{title}</h3>
        {description ? <p className="mx-auto mt-1 max-w-[44ch] text-[13px] text-muted-foreground">{description}</p> : null}
      </div>
      {action ? <div className="mt-1 flex flex-wrap items-center justify-center gap-2">{action}</div> : null}
    </div>
  );
}
